<template>
  <modal
    ref="intervalImport"
    name="interval-import"
    hide-footer
    title="Importovať intervalové dáta"
    @hidden="Object.assign($data, $options.data())"
    @ok="importData"
  >
    <file-upload
      ref="upload"
      v-model="file"
      :headers="{ Authorization: 'Bearer ' + $auth.token() }"
      :multiple="false"
      :post-action="'/api/reports/' + id + '/interval/import'"
      class="btn btn-sm btn-primary text-uppercase mr-1"
      :class="{ 'btn-disabled': uploading }"
      @input-file="inputFile"
    >
      <b-icon class="mr-1" icon="upload" />
      Nahrať súbor
    </file-upload>
    <template v-if="uploading">Prebieha import...</template>
  </modal>
</template>
<script>
import Modal from '@/components/Modal'
import FileUpload from 'vue-upload-component'
import moment from 'moment'

export default {
  components: {
    Modal,
    FileUpload,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      file: [],
      uploading: false,
      date: moment().startOf('month').subtract(1, 'month').format('YYYY-MM-DD'),
    }
  },
  methods: {
    inputFile(newFile, oldFile) {
      this.$refs.upload.active = true
      this.uploading = true
      if (newFile && oldFile) {
        if (newFile.progress !== oldFile.progress) {
        }
        if (newFile.success !== oldFile.success) {
          this.uploading = false
          this.closeModal()

          this.$swal({
            type: 'success',
            position: 'top',
            showCloseButton: true,
            text: newFile.response.message,
            timer: 5000,
          })
          this.$root.$emit('reports.reloadIntervalData')
        }
      }
    },
    importData() {},
    closeModal() {
      this.$refs.upload.clear()
      this.$root.$emit('modal-hide', 'interval-import')
    },
  },
}
</script>
